import { Column } from '~/commonComponents/Column';
import { Text } from '~/commonComponents/Text';
import { EmptyNewToYouProfessionalCopy } from '~/components/ProfessionalsHub/Constants';
import { Colors } from '~/themes/colors';

export const NoNewToYou = () => {
  return (
    <Column alignItems="center">
      <EmptyNewToYouProfessionalCopy.Icon size={136} />

      <Text bold color={Colors.neutral_500} fontSize={20} marginTop={18}>
        {EmptyNewToYouProfessionalCopy.title}
      </Text>
      <Text color={Colors.neutral_500} marginTop={18} textAlign="center" width={399}>
        {EmptyNewToYouProfessionalCopy.description}
      </Text>
    </Column>
  );
};
